<div
  class="word-garden"
  [class.kb-pinned]="kbPinned"
  [style.top.px]="kbPinned ? vvTop : null"
  [style.height.px]="kbPinned ? vvHeight : null"
>
  <!-- INTRO -->
  <ng-container *ngIf="phase === 'intro'">
    <div class="intro-header">
      <div class="cog-label intro-label">{{ 'cognitive.sharpV2.wordGarden.label' | translate }}</div>
      <h2 class="cog-h2">{{ 'cognitive.sharpV2.wordGarden.title' | translate }}</h2>
      <p class="cog-subtitle intro-sub">{{ 'cognitive.sharpV2.wordGarden.subtitle' | translate }}</p>
    </div>

    <div class="cog-card cog-card-accent category-card">
      <p class="prompt">{{ 'cognitive.sharpV2.wordGarden.yourCategoryIs' | translate }}</p>
      <div class="cat-name">{{ categoryKey | translate }}</div>
      <p class="example">
        {{ 'cognitive.sharpV2.wordGarden.forExample' | translate }}: {{ exampleKey | translate }}
      </p>
    </div>

    <div #demoField class="demo-garden">
      <div class="demo-tag">{{ 'cognitive.sharpV2.wordGarden.demoTag' | translate }}</div>
      <div class="demo-ground"></div>
      <div
        *ngFor="let fl of demoFlowers"
        class="flower demo-flower"
        [style.left.px]="fl.x"
        [style.z-index]="fl.z"
        [style.animation]="fl.anim + ' ' + fl.dur + 's ease both'"
        [style.transform]="'rotate(' + fl.rotate + 'deg)'"
        [innerHTML]="fl.html"
      ></div>
    </div>

    <div class="demo-explain" [class.visible]="demoExplainVisible">
      {{ 'cognitive.sharpV2.wordGarden.demoExplain' | translate }}
    </div>

    <div class="demo-input-row" aria-hidden="true">
      <div class="demo-input" [class.flash]="demoInputFlash">{{ demoInputText }}</div>
      <div class="demo-add-btn">+</div>
    </div>

    <p class="instructions">{{ 'cognitive.sharpV2.wordGarden.instructions' | translate }}</p>

    <button type="button" class="cog-btn cog-btn-primary start-btn" (click)="start()">
      {{ 'cognitive.sharpV2.wordGarden.start' | translate }}
    </button>
  </ng-container>

  <!-- ACTIVE -->
  <ng-container *ngIf="phase === 'active'">
    <div class="active-header">
      <div class="word-counter" [class.pop]="counterPop">{{ words.length }}</div>
      <div class="cat-pill">
        <span class="cat">{{ categoryKey | translate }}</span>
        <div class="cog-timer-ring" [class.urgent]="timeLeft <= 5" [style.--pct]="timerPct">
          <div class="cog-timer-inner">{{ timeLeft }}</div>
        </div>
      </div>
    </div>

    <div
      #field
      class="garden-field"
      (click)="onFieldClick()"
      [style.background]="fieldBackground"
      [style.border-color]="fieldBorderColor"
      [style.box-shadow]="fieldBoxShadow"
    >
      <div class="garden-ground"></div>
      <div
        *ngFor="let fl of flowers; trackBy: trackById"
        class="flower"
        [style.left.px]="fl.x"
        [style.z-index]="fl.z"
        [style.animation]="fl.anim + ' ' + fl.dur + 's ease both'"
        [style.transform]="'rotate(' + fl.rotate + 'deg)'"
        [innerHTML]="fl.html"
      ></div>
      <ng-container *ngFor="let ep of ephemerals; trackBy: trackById">
        <div [innerHTML]="ep.html"></div>
      </ng-container>
    </div>

    <div class="bottom-bar">
      <div class="feedback" [class.warn]="feedbackKind === 'warn'" [class.error]="feedbackKind === 'error'">
        {{ feedback ? (feedback | translate) : '' }}
      </div>
      <!-- PAUSED: page was hidden, the clock stopped (brief 3.3) -->
      <div class="wg-paused cog-card cog-text-center" *ngIf="paused">
        <h2 class="cog-h2">{{ 'cognitive.sharpV2.wordGarden.interruptedTitle' | translate }}</h2>
        <p class="cog-subtitle">{{ 'cognitive.sharpV2.wordGarden.interruptedBody' | translate }}</p>
        <button type="button" class="cog-btn cog-btn-primary" (click)="resumeAfterInterrupt()">
          {{ 'cognitive.sharpV2.wordGarden.interruptedCta' | translate }}
        </button>
      </div>
      <div class="input-row" [hidden]="paused">
        <input
          #inputEl
          type="text"
          class="cog-input wf-input"
          [(ngModel)]="inputValue"
          (ngModelChange)="onInputChange()"
          (keydown)="onKey($event)"
          [placeholder]="'cognitive.sharpV2.wordGarden.inputPlaceholder' | translate"
          autocomplete="off"
          autocapitalize="none"
          autocorrect="off"
          spellcheck="false"
          enterkeyhint="send"
          inputmode="text"
        />
        <button class="add-btn" type="button" (pointerdown)="keepFocus($event)" (mousedown)="keepFocus($event)" (click)="submitWord()">+</button>
      </div>
    </div>
  </ng-container>
</div>
